import React, { useState, useEffect, useRef, useContext } from 'react';

import { Button } from 'web-store-modules/packages/web-store-ui-library';
import FlyUpModal from '../FlyUpModal';
import { getFontStylesAsync, getStoreId, ukMKId, mexicoMKId, portugalMKId, argentinaMKId, brazilMKId } from '../../../../utils/StoreConfigManager';
import './VideoTextModal.css';
import { isMobileDevice } from 'web-store-modules/packages/obsess-device-detector';
import { constructUrl } from '../../../../utils/UrlConstructor';
import { AppContext } from "../../../../AppContext.jsx";
import { PlayClicked } from "../../../../utils/Analytics";
import ModalOverlay from '../ModalOverlay';
import ReactHtmlParser from "react-html-parser";

const storeId = getStoreId();
const isMobile = isMobileDevice();
const closeIcon = 'https://cdn.obsess-vr.com/dyson/close-icon-v2.png';
const mexicoVideoHotspotIds = ['613f64fa6dbab91a18aab5ed','613f66776dbab91a18aab60d', '5f878df86475f0929b4c9eb0'];
const brazilVideoHotspotIds = ['619837e8f981e9b40582e92b', '6198387dfaaa76a0ef7a2e6c', '619838dabe96d251a7472742'];
const ukVideoHotspotIds = ['610dabc29ed97ea76b08e099', '610dabc29ed97ea76b08e082', '610dabc29ed97ea76b08e095'];
const portugalVideoHotspotIds = ['619553409b96c033d8169caf','619553409b96c033d8169cbf','619553409b96c033d8169cc9'];
const argentinaVideoHotspotIds = ['619417d5069ba3d998002fc6','6194186aa07102d8864ab0df', '61941826f981e9b40582e411', '619d5e51be96d251a7472ae7'];

const VideoTextModal = ({ modalContent, onModalHidden, onClose, playIcon, videoId, hotspotId }) => {
    const { title, body, button_copy, button_url, url } = modalContent;
    const videoUrl = constructUrl(url)
    const [fontStyles, setFontStyles] = useState();
    const [modalActive, setModalActive] = useState();
    const [isPlaying, setIsPlaying] = useState(false);
    const modalRef = useRef();
    const videoElementRef = useRef();
    const { currentSceneName } = useContext(AppContext);

    useEffect(() => {
        fetchFontStyles();
        addListeners();
        
        return (() => {
            removeListeners();
        });

    }, []);

    const toggleVideo = () => {
        const videoElement = document.getElementById(videoId);
        if (isPlaying) {
            videoElement.pause();
        } else {
            PlayClicked(currentSceneName, url.path ? url.path.split('/').pop() : '');
            videoElement.play();
        }
        setIsPlaying(!isPlaying);
    };

    const addListeners = () => {
        if (isMobile) {
            window.addEventListener('touchend', handleModalClose);
        } else {
            window.addEventListener('click', handleModalClose);
        }
    }

    const removeListeners = () => {
        if (isMobile) {
            window.removeEventListener('touchend', handleModalClose);
        } else {
            window.removeEventListener('click', handleModalClose);
        }
    }

    const fetchFontStyles = () => {
        getFontStylesAsync()
            .then((fontStyles) => setFontStyles(fontStyles))
            .catch((err) => console.error(err));

    }

    const handleModalClose = (e) => {
        if (modalRef && modalRef.current.contains(e.target)) {
            return;
        }
        closeModal();
    }

    const closeModal = () => {
        if (onClose) {
            setModalActive(false);
            onClose();
        }
    }

    const handleClick = () => {
        const attRedirectPath = constructUrl(button_url);
        window.open(attRedirectPath, '_blank');
    }

    const productButton = () => {
        return (
            <div className="video-text-button-container"><Button
                hoverStyleChange={true}
                onClick={handleClick}
                primaryColor={'#333333'}
                secondaryColor={'#333333'}
                className="text-marker-button flex-center obsessvr-regularFont full-width pointer product-button"
                style={{ padding: '10px', margin: '0 1%', borderRadius: '0px', fontFamily: 'NotoSans-Regular', }}
                primaryBorderColor='white'
                secondaryBorderColor='white'
                primaryBorderWidth='0px'
                secondaryBorderWidth='0px'
                insetBorder={true}
                padded={false}
            >
                <p className='obsessvr-regularFont'>
                    {button_copy}
                </p>
            </Button></div>
        )
    }

    const textContainer = () => {
        return (
            <div className='video-text-modal-text-container'>
                <pre
                    style={{
                        fontSize: isMobile ? '18px' : '14px',
                        fontFamily: 'NotoSans-Regular',
                        whiteSpace: 'pre-wrap',
                        color: '#595959'
                    }}
                >
                    {ReactHtmlParser(body)}
                </pre>
            </div>
        )
    }

    const titleRender = () => {
        return (
            <div className='video-text-modal-title-container'>
                <span
                    style={{
                        fontSize: isMobile ? '60px' : '18px',
                        fontFamily: 'NotoSans-Regular'
                    }}>
                    {title}
                </span>
            </div>
        );
    }

    const onvideoEnded = () => {
        if(storeId === ukMKId &&  ukVideoHotspotIds.includes(hotspotId)) {
            videoElementRef.current.play()
        }
        if(storeId === mexicoMKId &&  mexicoVideoHotspotIds.includes(hotspotId)) {
            videoElementRef.current.play()
        }
        if(storeId === portugalMKId && portugalVideoHotspotIds.includes(hotspotId)) {
            videoElementRef.current.play()
        }
        if(storeId === argentinaMKId && argentinaVideoHotspotIds.includes(hotspotId)) {
            videoElementRef.current.play()
        }
        if(storeId === brazilMKId && brazilVideoHotspotIds.includes(hotspotId)) {
            videoElementRef.current.play()
        }
    }

    const mediaRender = () => {
        
        return (
            <div className='video-text-modal-subtitle-container'>
                <video
                    controls
                    autoPlay
                    loop
                    preload='auto'
                    playsInline
                    width='100%'
                    height='100%'
                    onEnded={onvideoEnded}
                    ref={videoElementRef}
                >
                    <source src={videoUrl + '#t=0.001'} />
                </video>


                {/* <img className="btnPlay" src={playIcon} onClick={toggleVideo}/> */}
            </div>
        );
    }

    const renderModalContent = () => {
        return (
            <div className='' style={{ textAlign: 'center' }} ref={modalRef}>
                {url && mediaRender()}
                {title && titleRender()}
                {body && textContainer()}
                {button_copy && productButton()}
            </div>
        )
    }
    return (
        //Added the isImage Loaded bool here to display the close button on the Modal due to a condition in Modal.jsx
        <FlyUpModal extraClassName="video-text-modal-container" onModalHidden={onModalHidden} isOpaque
            textPopup hideCloseIcon isImageLoaded closeIconImage={closeIcon}>
            <ModalOverlay />
            {!!fontStyles && renderModalContent()}
        </FlyUpModal>
    );
}

export default VideoTextModal;
